import React from "react";
import { LineGate, LineAuth } from "../types";

interface Props {
  lineGate: LineGate;
  lineAuth: LineAuth | null;
  lineAddFriendUrl: string | null;
  lineLoading: boolean;
  lineStatusChecking: boolean;
  primaryLineAction: { label: string; onClick?: () => void; disabled: boolean };
  refreshFriendStatus: () => void;
  onTroubleClick: () => void;
  t: (key: string, options?: Record<string, unknown>) => string;
}

export default function LineVerificationCard({
  lineGate,
  lineAuth,
  lineAddFriendUrl,
  lineLoading,
  lineStatusChecking,
  primaryLineAction,
  refreshFriendStatus,
  onTroubleClick,
  t,
}: Props) {
  return (
    <div className="line-verify-card mb-3">
      <div className="line-verify-header">
        <span className="line-verify-title">{t("line_verify_title")}</span>
      </div>
      {lineGate.type === "blocked" && (
        <p className="line-verify-hint line-verify-blocked">{t("line_verify_blocked")}</p>
      )}
      <button
        className={`btn-line-action${lineGate.passed ? " btn-line-verified" : lineGate.type === "blocked" ? " btn-line-blocked" : ""}`}
        type="button"
        onClick={primaryLineAction.onClick}
        disabled={primaryLineAction.disabled}
      >
        {!lineGate.passed && lineGate.type !== "blocked" && (
          <img src="/assets/common/images/line-app-icon.png" alt="LINE" className="line-btn-icon" />
        )}
        {lineGate.passed && (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
        <span>{primaryLineAction.label}</span>
      </button>
      {!lineGate.passed && lineGate.type !== "blocked" && lineAuth?.line_session_token && !lineAddFriendUrl && (
        <button className="btn-line-recheck" type="button" onClick={refreshFriendStatus} disabled={lineLoading || lineStatusChecking}>
          {t("line_help_recheck_btn")}
        </button>
      )}
      {lineAddFriendUrl && (
        <button className="btn-line-trouble-trigger" type="button" data-bs-toggle="modal" data-bs-target="#lineTroubleModal" onClick={onTroubleClick}>
          {t("line_help_trigger")}
        </button>
      )}
      {lineAuth?.customer?.customer_name && lineGate.passed && (
        <p className="line-signed-in-note">{t("line_signed_in_as", { name: lineAuth.customer.customer_name })}</p>
      )}
    </div>
  );
}
